import { getSessionMiniature } from 'src/utils';
import { Session } from 'src/models/Session';
import { Challenge, ChallengeSession, ChallengeType } from 'src/models/Challenge';
import { ChallengesService, SessionsService } from 'src/services';
import { BackNavigationInfo } from 'src/models/BackNavigationInfo';

export type SessionCardEntity = Session | Challenge | ChallengeSession;

export const resolveStyleName = (entity: SessionCardEntity) =>
  entity.contentType === 'challenge'
    ? undefined
    : entity.style?.name;

export const resolveOverlineLabel = (entity: SessionCardEntity) => {
  if (entity.contentType === 'challenge') {
    if (entity.type === ChallengeType.PracticePlan) {
      return 'Plan praktyki';
    }
    return 'Wyzwanie';
  }
  return resolveStyleName(entity) ?? '';
};

export const resolveTypeName = (entity: SessionCardEntity) =>
  entity.contentType === 'challenge'
    ? undefined
    : entity.type?.[0]?.name ?? '';

export const resolveImage = (mode: 'horizontal' | 'vertical', entity: SessionCardEntity) => {
  if (mode === 'horizontal') {
    if (entity.horizontalThumbnail) return entity.horizontalThumbnail;
    const fromVideo = getSessionMiniature(entity.video?.thumbnail, 800);
    if (fromVideo) return fromVideo;
    if ('verticalThumbnail' in entity && entity.verticalThumbnail) {
      return entity.verticalThumbnail;
    }
    return undefined;
  }
  if ('verticalThumbnail' in entity) {
    return entity.verticalThumbnail ?? undefined;
  }
};

export const resolveDuration = (mode: 'horizontal' | 'vertical', entity: SessionCardEntity): number | undefined => {
  if ('duration' in entity && entity.contentType === 'challenge') {
    return entity.duration ?? undefined;
  }
  return entity.video?.duration ?? undefined;
};

export const composeLink = (item?: SessionCardEntity, backInfo?: BackNavigationInfo, pathBase?: string) => {
  if (!item) {
    return
  }

  let pathname: string;
  if (item.contentType === 'challengeSession') {
    pathname = `/challenges/session/${item.id}`;
  } else {
    const defaultPathBase = item.contentType === 'session' ? 'sessions' : 'challenges';
    pathname = `/${pathBase ?? defaultPathBase}/${item.id}`;
  }

  const queryParam = backInfo ? BackNavigationInfo.serializeToUrlParams(backInfo) : '';

  return `${pathname}${queryParam ? `?${queryParam}` : ''}`;
};

export const toggleLike = async (item: SessionCardEntity, status: boolean) => {
  if (item?.contentType === 'session') {
    await SessionsService.toggleLiked(item.id, status);
    return;
  }
  if (item?.contentType === 'challenge') {
    await ChallengesService.toggleChallengeLiked(item.id, status);
    return;
  }
  if (item?.contentType === 'challengeSession') {
    await ChallengesService.toggleChallengeSessionLiked(item.id, status);
    return;
  }
  throw new Error('Could not toggle like');
};
